<form [formGroup]="form" (ngSubmit)="save()" class="flex flex-col max-h-[82vh]">
  <div class="flex flex-col gap-4 p-5 overflow-y-auto">
    <!-- Top Context Card -->
    <div class="p-3.5 rounded-xl bg-surface border border-border flex items-center justify-between gap-3 flex-wrap">
      <div class="flex items-center gap-2.5 min-w-0">
        <div class="w-9 h-9 rounded-lg bg-primary-low-contrast text-primary flex items-center justify-center shrink-0">
          <lucide-icon name="Wallet" size="16"></lucide-icon>
        </div>
        <div class="flex flex-col min-w-0">
          <app-text size="sm" weight="semibold" class="truncate text-foreground">
            {{ driverDisplayName() }}
          </app-text>
          <app-text size="xs" color="muted">
            {{ legSummaryLabel() }} &middot; {{ loadedMiles() | number }} loaded mi
          </app-text>
        </div>
      </div>

      @if (currentBasePayDisplay() !== null) {
        <div class="flex flex-col items-end shrink-0">
          <app-text size="xs" color="muted">Current Base Pay</app-text>
          <app-text size="sm" weight="bold" class="text-foreground">
            {{ currentBasePayDisplay() | currency }}
          </app-text>
        </div>
      } @else {
        <app-badge variant="secondary" size="xs" title="Per-Leg Pay"></app-badge>
      }
    </div>

    <!-- Card 1: Leg Base Pay -->
    <app-form-card title="Leg Base Pay" icon="Banknote">
      <app-form-field
        label="Base Pay Calculation"
        hint="Auto uses this driver's configured Pay Structure ($/mi, % of gross, hourly, or flat). Choose Custom Flat Rate only for special relay or rescue agreements."
      >
        <app-button-group
          [options]="payModeOptions"
          [ngModel]="payMode()"
          (ngModelChange)="onPayModeChange($event)"
          [ngModelOptions]="{ standalone: true }"
        ></app-button-group>
      </app-form-field>

      @if (payMode() === 'override') {
        <app-form-field
          label="Agreed Flat Leg Base Pay"
          hint="Replaces mileage or percentage base pay for this leg. Stop pay, detention & lumper reimbursements still apply."
          [required]="true"
        >
          <app-number-input
            formControlName="manualPayOverride"
            currency="USD"
            [showGrouping]="true"
            [min]="0"
            placeholder="0.00"
          ></app-number-input>
        </app-form-field>

        <app-form-field
          label="Rate Agreement Note (Optional)"
          hint="Visible on the driver's mobile pay breakdown and settlement statement"
        >
          <app-input
            formControlName="manualPayOverrideNote"
            placeholder="e.g. Agreed $250 local relay rescue rate"
          ></app-input>
        </app-form-field>
      }
    </app-form-card>

    <!-- Card 2: Optional Deadhead / Positioning Miles -->
    <app-form-card
      title="Unpaid Positioning / Deadhead Miles (Optional)"
      icon="Navigation"
      [collapsible]="true"
      [defaultCollapsed]="!hasExistingDeadhead()"
    >
      <app-text size="xs" color="muted">
        Only needed if this driver's Pay Structure pays an Empty / Deadhead Mile rate and they drove empty outside the load's route.
      </app-text>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <app-form-field
          label="Deadhead Miles to Leg Start"
          hint="Empty miles driven to reach pickup / relay"
        >
          <app-number-input
            formControlName="emptyMilesOrigin"
            mode="decimal"
            [min]="0"
            [showGrouping]="true"
            suffixText="mi"
            placeholder="0"
          ></app-number-input>
        </app-form-field>

        <app-form-field
          label="Empty Return Miles After Drop"
          hint="Bobtail or empty miles back to yard after drop"
        >
          <app-number-input
            formControlName="emptyMilesDestination"
            mode="decimal"
            [min]="0"
            [showGrouping]="true"
            suffixText="mi"
            placeholder="0"
          ></app-number-input>
        </app-form-field>
      </div>
    </app-form-card>
  </div>

  <div class="flex items-center justify-end gap-3 p-4 border-t border-border bg-surface-low rounded-b-xl">
    <app-button variant="ghost" type="button" (click)="cancel()" [disabled]="isSaving()">
      Cancel
    </app-button>
    <app-button variant="primary" type="submit" [loading]="isSaving()" icon="Check">
      Save Leg Pay
    </app-button>
  </div>
</form>
